import React, { useEffect, useState } from "react";
import ModalTaskList from "./ModalTaskList";
import { NetworkManager } from "../../../Components/NetworkManager";
import { CommonUtil } from "../../../utils/CommonUtil";
import Confirm from "../../../Components/confirm";
import ToastManager from "../../../Components/ToastManager";

const NestedList = ({ items, level = 0, refreshTaskList }: any) => {
  const [hoveredItemId, setHoveredItemId] = useState<number | null>(null);
  return (
    <div style={{
      marginLeft: level === 1 ? "10px" : level === 2 ? "10px": level === 3 ? "9px": "12px",
      width: level === 1 ? "98.8%" : level === 2 ? "98.7%" : level === 3 ? "98.6%" : "96.9%",
    }}>
      {items.map((item: any, i:any) => (
        <NestedListItem key={i} item={item} level={level} 
        hoveredItemId={hoveredItemId} fullTaskList={items}
        setHoveredItemId={setHoveredItemId} refreshTaskList={refreshTaskList}/>
      ))}
    </div>
  );
};

const NestedListItem = ({ item, level, hoveredItemId, setHoveredItemId, fullTaskList, refreshTaskList }: any) => {
  const sassOrgId = CommonUtil.getSaasOrgId();
  const [modalType, setModalType] = useState<"equipment" | "task" | "subtask" | null>(null);
  const [isEdit, setIsEdit] = useState<"equipment" | "task" | "subtask" | null>(null);
  const [expanded, setExpanded] = useState<any>(false);
  const [showPopup, setShowPopup] = useState<any>(false);
  const [modalData, setModalData] = useState<any>({});
  const [tasks, setTasks] = useState<any>([item]);

  const hasDirectChildren = item?.children && item?.children.length > 0;
  const isHovered = hoveredItemId === item.id;

  const onLoginError = (err: any) => {
    console.log(err);
  };
  
  const handlePopup = (type: any) => {
      if(type === "save" || type === "add") {
        refreshTaskList(); 
      }
      if(type !== "add") {
      setShowPopup(false);
      setModalType(null);
      }
      setIsEdit(null);
  }
  const onDropDownClick = (e: any) => {
    hasDirectChildren && setExpanded(!expanded);
  };

  const onAddOrEdit = (e :any, type: any, item: any, isEdit?: any) => {
    console.log(type, "type", item);
    e.stopPropagation();
    setModalType(type);
    setModalData(item);
    setShowPopup(true);
    if(isEdit == "edit"){
      setIsEdit(type);
    }
  }

  const handleDelete = (e: any, type: any, id: any) => {
    e.stopPropagation();
    Confirm.show("Confirm", `Would you like to delete this ${type === "task" ? "Task" : type === "subtask" ? "Subtask" : "Equipment"}?`, [
      {
        label: "Yes",
        callback: function () {
          if (id) {
            let api = `api/v2/config/${type === "task" ? "tasks" : type === "subtask" ? "subtasks" : ""}/${id}?orgId=${sassOrgId}`;
            NetworkManager.sendJsonRequest(api, "", "", "DELETE", true, onDeleteSuccess, onLoginError);
          }
        },
      },
      { label: "No" },
    ]);
  };

  const handleEquipDelete = (e:any, id: any, processId: any) => {
    e.stopPropagation();
    Confirm.show("Confirm", `Would you like to delete this Equipment?`, [
      {
        label: "Yes",
        callback: function () {
          if (id && processId) {
            let api = `api/v2/config/task-equipment-types/?dataInsertId=${id}&orgId=${sassOrgId}&processId=${processId}`;
            NetworkManager.sendJsonRequest(api, "", "", "DELETE", true, onDeleteSuccess, onLoginError);
          }
        },
      },
      { label: "No" },
    ]);
  }

  const onDeleteSuccess = (dataObj: any) => {
    refreshTaskList();
    if (dataObj) {
      var restData = CommonUtil.parseData(dataObj);
      if (!restData?.errorMessage && restData) {
        ToastManager.showToast(`Deleted Successfully`, "Info");
      }else{
        ToastManager.showToast(restData.errorMessage, "Error");
      }
    }
  }

  const stylebg: any = expanded
    ? styles[`level${level + 1}Expandedbg`] || styles[`level1Expandedbg`]
    : styles[`level${level + 1}bg`] || styles[`level1bg`];
    
  const handleDragStart = (event: any, task: any) => {
    event.dataTransfer.effectAllowed = "move";
    event.dataTransfer.setData("application/json", JSON.stringify(task));
  };

  const handleDragOver = (event: any) => {
    event.preventDefault();
  };

  const handleDrop = (event: any, targetItem: any) => {
      event.preventDefault();
      const draggedData = event.dataTransfer.getData("application/json");
      const draggedItem = JSON.parse(draggedData);
      if (!draggedItem || 
        (draggedItem.taskId === targetItem.taskId) || 
        !targetItem.taskId || 
        (targetItem?.processId !== draggedItem?.processId ) || 
        (targetItem?.equipmentTypeGroupId !== draggedItem?.equipmentTypeGroupId )){
        return;
      }
      const updatedList = fullTaskList
        .map((item: any) => {
          if (typeof item.sequenceId === "undefined") {
            return { ...item, sequenceId: tasks.length + 1 };
          }
          return item;
        })
        .map((item: any) => {
          if (item.taskId === draggedItem.taskId)
            return { ...item, sequenceId: targetItem.sequenceId };
  
          if (
            draggedItem.sequenceId < targetItem.sequenceId &&
            item.sequenceId > draggedItem.sequenceId &&
            item.sequenceId <= targetItem.sequenceId
          ) {
            return { ...item, sequenceId: item.sequenceId - 1 };
          }
          if (
            draggedItem.sequenceId > targetItem.sequenceId &&
            item.sequenceId < draggedItem.sequenceId &&
            item.sequenceId >= targetItem.sequenceId
          ) {
            return { ...item, sequenceId: item.sequenceId + 1 };
          }
          return item;
        })
        .sort((a: any, b: any) => a.sequenceId - b.sequenceId);
        
      setTasks(updatedList);
      // setDraggedItem(null);
      updateSequenceAPI(updatedList);
    };
    
  const updateSequenceAPI = async (updatedList: any) => {
    const payload = updatedList.map((item: any, index: any) => ({
      sequenceId: index + 1,
      taskId: item.taskId,
      taskName: item.taskName,
    }));
    const url = `api/v2/config/task/sequence?orgId=${sassOrgId}`;
    NetworkManager.sendJsonRequest(url, payload, "", "POST", true, onUpdateSequence, onLoginError);
  };

  const onUpdateSequence = (dataObj: any) => {
    if (dataObj) {
      const restData = JSON.parse(dataObj);
      if (restData && !restData.errorMessage) {
        ToastManager.showToast("Sequence Updated Successfully", "Info");
      }else{
        ToastManager.showToast(restData.errorMessage, "Error");
      }
      refreshTaskList();
    }
  };
  return (
    <>
    <div className={`row`}
      onMouseEnter={() => setHoveredItemId(item.id)}
      onMouseLeave={() => setHoveredItemId(null)}
    >
      <div className="arrowBorder" 
        style={{
            borderBottom: "1px dotted #9f9f9f",
            position: "relative",
            left: "-35px",
            top: "25px",
            zIndex: 1,
            }}></div>
      <div
        style={styles.itemWrapper}
        onClick={(e) => onDropDownClick(e)}
        className="row col-12  align-items-center"
        draggable={level===2 && fullTaskList.length > 1}
        onDragStart={(event) => handleDragStart(event, item)}
        onDragOver={handleDragOver}
        onDrop={(event) => handleDrop(event, item)}
      >
        <div
          className={`col-md-9 ${level === 2 ? "py-1" : "py-1"} px-2 mt-0 d-flex justify-content-start`}
          style={stylebg}
        >
          {hasDirectChildren ? (
            <span className="me-3">
              {expanded ? (<i className="fa-solid fa-chevron-down"></i>) : (<i className="fa-solid fa-chevron-right"></i>)}
            </span>
          ) : (
            <span className="me-2"></span>
          )}
          <span style={styles.itemText} className={`d-flex flex-column fs-12 ${!hasDirectChildren && level === 0 ? "ms-4": ""}`}>
            <span className={`${item.name?.length > 95 ? "text-truncate" : ""}`} 
              title={item.name?.length > 95 && item.name}
              style={{maxWidth: item.name?.length > 95 ? "640px" : "none", fontWeight: level === 0 ? 600 : 500}}>
              {(level === 2 && fullTaskList.length > 1 )&& <span className="overflow-auto" style={{visibility: isHovered ? "visible" : "hidden"}}><i className="fa-solid fa-grip-vertical me-2 tasklist-drag"></i></span>}
             {`${level === 0 ? "Process" : level === 1 ? "Equipment" : level === 2 ? "Task" : level > 2 ? "Subtask" : ""} ${item.sequenceId}: `}
              {item.name}
            </span>
            {level === 1 ? (
              <span className="ms-2 mt-1" style={{ fontSize: "smaller", fontWeight: 400 }}>
                {level === 1 && `${item?.children?.length ? item?.children?.length : "0"} Tasks`}
              </span>
            ) : level === 0 ? (
              <span className="ms-2 mt-1" style={{ fontSize: "smaller", fontWeight: 400 }}>
                {item?.children?.length > 0 ? `${item?.children?.length} Equipments` : "No tasks added yet"}
              </span>
            ) : level === 2 ? (
              <span className="ms-4 mt-1" style={{ fontSize: "smaller", fontWeight: 400 }}>
                {`Type: ${item.processType}`}
              </span>
            ) : <span style={{height: "18px"}}></span>}
          </span>
        </div>
        <div className={`col-md-3 ${level === 2 ? "py-1" : "py-1"} px-2 mt-0 text-end`} style={stylebg}>
          {level === 0 ? (
            <button type="button" className="btn btn-secondary me-1" onClick={(e) => onAddOrEdit(e, "equipment", item)}>
              <div className="d-flex justify-content-center align-items-center">
                <i className="fa-solid fa-plus me-1 mt-0 fs-11"></i>
                <span className="fs-12">Add Equipment Type</span>
              </div>
            </button>
          ) : level === 1 ? (
            <div className="d-flex justify-content-end align-items-center">
              <div className={`${item?.children?.length == 0 ? "d-flex" : "d-none"} justify-content-end align-items-center`} style={{visibility: isHovered ? "visible" : "hidden"}}>
                <button type="button" title="Delete" className={`btn btn-icon`}
                  onClick={(e) => handleEquipDelete(e, item?.id, item?.processId)}>
                    <img src={ "./../images/delete.svg"} alt="delete" width={22} height={22}/>
                </button>
              </div>
              <button type="button" className="btn btn-secondary" onClick={(e) => onAddOrEdit(e, "task", item)}>
                <div className="d-flex justify-content-center align-items-center">
                  <i className="fa-solid fa-plus me-1 mt-0 fs-11"></i>
                  <span className="fs-12">Add Task</span>
                </div>
            </button>
          </div>
          ) : level === 3 ? (
            <div style={{visibility: isHovered ? "visible" : "hidden"}}>
              <button type="button" title="Edit" className={`btn btn-icon`}
                onClick={(e) => onAddOrEdit(e, "subtask", item, "edit")}>
                <img src={ "./../images/edit.svg"} alt="edit" width={18} height={18}/>
              </button>
              <button type="button" title="Delete" className={`btn btn-icon`}
                onClick={(e) => handleDelete(e, "subtask", item?.id)}
              ><img src={ "./../images/delete.svg"} alt="delete" width={18} height={18}/>
              </button>
            </div>
          ) : level === 2 ? (
            <div className="d-flex justify-content-end align-items-center">
              <div className="d-flex" style={{visibility: isHovered ? "visible" : "hidden"}}>
                <button type="button" title="Edit" className={`btn btn-icon`}
                  onClick={(e) => onAddOrEdit(e, "task", item, "edit")}
                ><img src={ "./../images/edit.svg"} alt="edit" width={18} height={18}/>
                </button>
                <button type="button" title="Delete" className={`btn btn-icon`}
                  onClick={(e) => handleDelete(e, "task", item?.taskId)}
                ><img src={ "./../images/delete.svg"} alt="delete" width={18} height={18}/>
                </button>
              </div>
              {/* <button type="button" style={{padding: "0.590rem 0.35rem", borderRadius:"3px"}} className=" btn-secondary" onClick={(e) => onAddOrEdit(e, "subtask" item)}>
                <div className="d-flex justify-content-center align-items-center">
                  <i style={{fontSize:"10px"}} className="fa-solid fa-plus me-1 mt-0"></i>
                  <span style={{fontSize:"11px"}}>Sub Task</span>
                </div>
              </button> */}
            </div>
          ) : (
            <div
              className={`col-md-10 text-right`}
              style={{visibility: isHovered ? "visible" : "hidden", height: "45px"}}
            ></div>
          )}
        </div>
      </div>
      {expanded && item.children && (
          <div style={styles.childrenWrapper}>
            <div className="task-border">
              <NestedList items={item.children} level={level + 1} refreshTaskList={refreshTaskList} />
            </div>
        </div>
        )}
      </div>
    {showPopup && <ModalTaskList open={showPopup} close={handlePopup} data={modalData} modalType={modalType} isEdit={isEdit} />}
    </>
  );
};

const transformTaskList = (taskList: any) => {
  return taskList.map((process: any, i:any) => ({
    id: process.processId,
    name: process.processName,
    sequenceId: i+1,
    children: process.eqipmentTypes?.map((equip: any, i:any) => {
      const keys = Object.keys(equip?.eqipmentTypes);
      const equipmentTypes = process.eqipmentTypes?.flatMap((item:any) => 
        Object.entries(item?.eqipmentTypes).map(([key, value]) => ({
          equipmentType: key,
          value: value
        }))
      );

      return {
        id: equip?.equipmentTypeGroupId,
        equipmentTypes: equipmentTypes,
        equipmentName: keys.join(", "),
        name: keys.join(", "),
        processId: process.processId,
        processName: process.processName,
        equipmentTypeGroupId: equip?.equipmentTypeGroupId,
        sequenceId: i+1,
        children: equip.tasks?.map((task: any, i: any) => ({
          ...task,
          id: task?.taskId,
          name: task.taskName,
          equipmentName: keys.join(", "),
          processName: process.processName,
          equipmentTypeGroupId: equip?.equipmentTypeGroupId,
          sequenceId: i+1,
          // children: task.subTasks?.map((subTask: any, i: any) => ({
          //   ...task,
          //   id: subTask.subTasksId,
          //   name: subTask.subTaskName,
          //   subTaskId: subTask.subTasksId,
          //   equipmentTypeGroupId: equip?.equipmentTypeGroupId,
          //   description: subTask.subTaskDescription,
          //   equipmentName: keys.join(", "),
          //   processName: process.processName,
          //   sequenceId: i+1,
          // })) || [],
        })) || [],
      };
    }) || [],
  }));
};

const TaskList = () => {
  const sassOrgId = CommonUtil.getSaasOrgId();
  const [taskList, setTaskList] = useState<any[]>([]);

  useEffect(() => {
    getTaskList();
  }, []);


  const getTaskList = () => {
    const orgUrl = `api/v2/config/task-equipment-types/${sassOrgId}`;
    NetworkManager.sendJsonRequest( orgUrl, "", "", "GET", true, (dataObj: any) => {
      if (dataObj) {
        const restData = JSON.parse(dataObj);
        if (restData && restData.length > 0) {
          setTaskList(restData);
        } else {
          setTaskList([]);
        }
      }
    }, (err: any) => {
      console.log(err);
    });
  };
  
  const transformedData = transformTaskList(taskList);
  return (
    <div style={styles.container}>
    <div className={`col-lg-12 `}>
      <div className={`d-flex p-3 ${taskList.length > 0 ? "d-none" : ""}`}>
        <span><i className="fa fa-info-circle me-3 icon-muted"></i></span>
        <div className="fw-400 text-muted">
          <span className="fw-600 text-dark">Task list has no data</span>
          <br></br>Add Process from the previous screen 
        </div>
      </div>
    </div>
    <NestedList items={transformedData} refreshTaskList={getTaskList} />
    </div>
  );
};

const styles: any = {
  container: {overflowY: "auto", overflowX: "hidden", height:`${window.innerHeight - 160}px`},
  listContainer: { marginLeft: "12px", width:"97%", },
  level1Expandedbg: { backgroundColor: "#F9FAFB" },
  level1bg: { backgroundColor: "white" },
  itemWrapper: { zIndex: 2, padding: "0px", margin: "0px 0", cursor: "pointer",  border: "1px solid #D0D5DD", marginBottom:"6px" },
  itemText: { color: "black", fontSize: "16px" },
  childrenWrapper: { paddingLeft: "36px", backgroundColor: "#ffffff" /*#F9FAFB */ },
};

export default TaskList;
